import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  VStack,
  Text,
  Button,
} from "@chakra-ui/react";

/**
 * ActivityRemixModalContainer - Barebone container for remix modal flows
 * Provides consistent styling and layout for different remix modal types
 */
const ActivityRemixModalContainer = ({
  isOpen,
  onClose,
  title,
  primaryButtonTitle = "Continue",
  secondaryButtonTitle = "Cancel",
  onPrimaryClick,
  onSecondaryClick,
  isPrimaryLoading = false,
  primaryLoadingText = "Processing...",
  children,
  primaryButtonTestId = "primary-button",
  secondaryButtonTestId = "secondary-button",
  ...props
}) => {
  const handlePrimaryClick = () => {
    onPrimaryClick?.();
  };

  const handleSecondaryClick = () => {
    onSecondaryClick?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
      size="sm"
      {...props}
    >
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent
        bg="linear-gradient(180deg, #DBDAF5 0%, #F8F8FF 20%, white 100%)"
        borderRadius="32px 32px 0 0"
        maxW="425px"
        mx="16px"
        mb={0}
        mt="auto"
        position="relative"
        overflow="visible"
      >

        <ModalBody p="32px 16px 16px">
          <VStack spacing={8} align="stretch">
            {/* Title Section */}
            {title && (
              <Text
                fontSize="24px"
                fontWeight="700"
                lineHeight="1.33"
                letterSpacing="-0.04em"
                color="#0C001C"
                textAlign="left"
                fontFamily="Geist, sans-serif"
              >
                {title}
              </Text>
            )}

            {/* Dynamic Content */}
            {children && <Box>{children}</Box>}

            {/* Button Section */}
            <VStack spacing={4} align="stretch">
              {/* Primary Button */}
              {primaryButtonTitle && (
                <Button
                  bg="#4C47CC"
                  color="white"
                  fontFamily="Geist, sans-serif"
                  fontWeight="700"
                  fontSize="13px"
                  lineHeight="1.23"
                  h="auto"
                  py={4}
                  px="55px"
                  borderRadius="8px"
                  isLoading={isPrimaryLoading}
                  loadingText={primaryLoadingText}
                  onClick={handlePrimaryClick}
                  _hover={{
                    bg: "#3D37B8",
                  }}
                  _active={{
                    bg: "#332A9F",
                  }}
                  data-testid={primaryButtonTestId}
                >
                  {primaryButtonTitle}
                </Button>
              )}

              {/* Secondary Button */}
              {secondaryButtonTitle && (
                <Button
                  variant="ghost"
                  color="#0C001C"
                  fontFamily="Geist, sans-serif"
                  fontWeight="700"
                  fontSize="13px"
                  lineHeight="1.23"
                  h="auto"
                  py={2}
                  onClick={handleSecondaryClick}
                  _hover={{
                    opacity: 0.8,
                  }}
                  data-testid={secondaryButtonTestId}
                >
                  {secondaryButtonTitle}
                </Button>
              )}
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ActivityRemixModalContainer;
